import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { getTranslations } from '../utils/translations';
import './Feedback.css';

const feedbacks = [
  {
    name: 'Ahmad Al-Rashid',
    rating: 5,
    comment: 'Exceptional service from start to finish! The trip planning was flawless and every detail was meticulously handled. The premium accommodations exceeded our expectations, and the team was always available to assist. Highly recommend for both business and leisure travel.',
    location: 'Dubai, UAE'
  },
  {
    name: 'Sarah Johnson',
    rating: 5,
    comment: 'Sefarium made our European vacation unforgettable. From the luxurious hotel rentals with stunning views to seamless car rental service, everything was perfect. The attention to detail and personalized service truly sets them apart.',
    location: 'New York, USA'
  },
  {
    name: 'Mohamed Hassan',
    rating: 4.5,
    comment: 'Outstanding experience with Sefarium Premium Travel Services. The business meeting arrangements were professional and efficient. The high-standard apartments were exactly as described, and the support team was responsive throughout our stay.',
    location: 'Cairo, Egypt'
  },
  {
    name: 'Emma Thompson',
    rating: 5,
    comment: 'Absolutely delighted with the service! The cozy wooden house with jacuzzi was a dream come true. The trip planning service is comprehensive and well-organized. Sefarium truly understands what premium travel means.',
    location: 'London, UK'
  },
  {
    name: 'Layla Al-Mansouri',
    rating: 5,
    comment: 'We had an amazing experience with Sefarium. The car rental fleet is impressive, and the vehicles are in pristine condition. The team went above and beyond to ensure our comfort and satisfaction. Will definitely use their services again!',
    location: 'Abu Dhabi, UAE'
  },
  {
    name: 'James Wilson',
    rating: 4.5,
    comment: 'Professional, reliable, and luxurious - that\'s Sefarium in three words. The trip planning for our corporate retreat was executed flawlessly. Every recommendation was spot-on, and the accommodations were truly premium quality.',
    location: 'Sydney, Australia'
  }
];

const StarRating = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className="star-rating">
      {[...Array(fullStars)].map((_, i) => (
        <span key={i} className="star star-full">★</span>
      ))}
      {hasHalfStar && <span className="star star-half">★</span>}
      {[...Array(emptyStars)].map((_, i) => (
        <span key={i} className="star star-empty">★</span>
      ))}
      <span className="rating-number">{rating}</span>
    </div>
  );
};

export default function Feedback() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  
  return (
    <section id="feedback" className="feedback">
      <div className="feedback-container">
        <h2 className="feedback-title">{t.feedback.title}</h2>
        <p className="feedback-subtitle">
          {t.feedback.subtitle}
        </p>
        <div className="feedback-grid">
          {feedbacks.map((feedback, index) => (
            <div key={index} className="feedback-card">
              <div className="feedback-header">
                <div className="feedback-avatar">
                  {feedback.name.charAt(0)}
                </div>
                <div className="feedback-info">
                  <h3 className="feedback-name">{feedback.name}</h3>
                  <p className="feedback-location">{feedback.location}</p>
                </div>
              </div>
              <StarRating rating={feedback.rating} />
              <p className="feedback-comment">{feedback.comment}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

